import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
import { transformFiltersToQuery, transformRateToPrice } from '../framework/utils/FiltersUtils';
class SearchAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "search", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filters, offset = 0, limit = 10, sortQuery = '', carId = null) => {
                const query = transformFiltersToQuery(filters);
                const transformedQuery = transformRateToPrice(query);
                if (carId) {
                    return this.privateRequest('get', `search/car/${carId}/alternative?limit=${limit}&offset=${offset}${sortQuery}`, transformedQuery);
                }
                else {
                    return this.privateRequest('get', `search/car/formatted?limit=${limit}&offset=${offset}${sortQuery}`, transformedQuery);
                }
            }
        });
        this.setConfig(config);
    }
}
export default new SearchAPI({
    baseURL: config.alternativeSearchAPI.url
});
